import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs';
import {IBrand} from '../../types/IBrand';
import {IPriority} from '../../types/IPriority';
import {IVendorPriority} from '../../types/IVendorPriority';

@Injectable({
  providedIn: 'root'
})
export class ClientSettingsService extends BaseApiService {
  getSettings(client_id: string) {
    return this.get<{ data: any }>(`clients/${client_id}/settings`).pipe(
      map(response => response.data)
    );
  }

  updateSetting(client_id: string, key: string, value: any) {
    return this.post(`clients/${client_id}/settings`, {key, value});
  }

  getBrands(client_id: string) {
    return this.get<{ brands: IBrand[] }>(`clients/${client_id}/brands/mappings`).pipe(
      map(response => response.brands.map((brand) => {
        return {
          id: brand.id,
          name: brand.name,
          vendors: brand.vendors.map((vendor) => {
            return {key: vendor.key, name: vendor.name}
          })
        }
      }))
    );
  }

  getBrandPriorities(client_id: string) {
    return this.get< IPriority[] >(`clients/${client_id}/brand-priorities`);
  }

  updateBrandPriorities(client_id: string, priorities: any) {
    return this.post(`clients/${client_id}/brand-priorities`, {priorities});
  }

  getBrandVendorPriorities(client_id: string) {
    return this.get< IVendorPriority[]>(`clients/${client_id}/vendor-priorities`);
  }

  updateBrandVendorPriorities(client_id: string, brand_id: string|number, priorities: any) {
    return this.post(`clients/${client_id}/vendor-priorities`, {priorities, brand_id});
  }
}
